import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import HomeViewMain from '@/views/HomeViewMain.vue'
import HomeViewSide from '@/views/HomeViewSide.vue'
import RecordViewMain from '@/views/RecordViewMain.vue'
import RecordViewSide from '@/views/RecordViewSide.vue'
import AboutViewMain from '@/views/AboutViewMain.vue'
import AboutViewSide from '@/views/AboutViewSide.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    components: {
      default: HomeViewMain,
      siderouterview: HomeViewSide,
    },
    beforeEnter(to, from, next) { //Will be called before link is entered
      store.commit('updateMenuOpened', false)
      store.commit('updateCurrentView', 'homeview')
      /* eslint-disable no-console */
      //console.log('beforeEnter * ; currentRecordType is ' + store.getters.currentRecordType)
      /* eslint-enable no-console */ 
      next()
    },
  },
  {
    path: '/',
    components: {
      default: HomeViewMain,
      siderouterview: HomeViewSide,
    },
    beforeEnter(to, from, next) { //Will be called before link is entered
      store.commit('updateMenuOpened', false)
      store.commit('updateCurrentView', 'homeview')
      /* eslint-disable no-console */
      //console.log('beforeEnter / ; currentRecordType is ' + store.getters.currentRecordType)
      /* eslint-enable no-console */ 
      next()
    },
  },
  {
    path: '/records/typeface',
    components: {
      default: RecordViewMain,
      siderouterview: RecordViewSide,
    },
    beforeEnter(to, from, next) { //Will be called before link is entered; beforeEnter
      
      store.commit('updateCurrentRecordType', 'typeface')
      store.commit('updateCurrentView', 'recordview')
      store.commit('updateMenuOpened', false)
      next()
    },
  },
  {
    path: '/records/typeface/:recordid',
    components: {
      default: RecordViewMain,
      siderouterview: RecordViewSide,
    },
    beforeEnter(to, from, next) { //Will be called before link is entered; beforeEnter

      store.commit('updateMenuOpened', true)
      store.commit('updateCurrentRecordType', 'typeface')
      store.commit('updateCurrentView', 'recordview')

      //Could theoretically put some of the recordview main conditional statements here
      //Would need to get both the entire typeface set and then also the specific typeface set
      /* eslint-disable no-console */
      
      /* eslint-enable no-console */ 

      /* eslint-disable no-console */
      //console.log('beforeEnter records/typeface ; currentRecordType is ' + store.getters.currentRecordType)
      /* eslint-enable no-console */ 
      next()
    },
  },
  {
    path: '/records/concept',
    components: {
      default: RecordViewMain,
      siderouterview: RecordViewSide,
    },
    beforeEnter(to, from, next) { //Will be called before link is entered

      store.commit('updateCurrentRecordType', 'concept')
      store.commit('updateCurrentView', 'recordview')
      store.commit('updateMenuOpened', false)
      next()
    },
  }, 
  {
    path: '/records/concept/:recordid',
    components: {
      default: RecordViewMain,
      siderouterview: RecordViewSide,
    },
    beforeEnter(to, from, next) { //Will be called before link is entered; beforeEnter

      store.commit('updateMenuOpened', true)
      store.commit('updateCurrentRecordType', 'concept')
      store.commit('updateCurrentView', 'recordview')
      next()
    },
  },
  {
    path: '/records/resource',
    components: {
      default: RecordViewMain,
      siderouterview: RecordViewSide,
    },
    beforeEnter(to, from, next) { //Will be called before link is entered

      
      store.commit('updateCurrentRecordType', 'resource')
      store.commit('updateCurrentView', 'recordview')
      store.commit('updateMenuOpened', false)
      next()
    },
  },
  {
    path: '/records/resource/:recordid',
    components: {
      default: RecordViewMain,
      siderouterview: RecordViewSide,
    },
    beforeEnter(to, from, next) { //Will be called before link is entered; beforeEnter
      
      store.commit('updateMenuOpened', true)
      store.commit('updateCurrentRecordType', 'resource')
      store.commit('updateCurrentView', 'recordview')
      next()
    },
  },
  {
    path: '/about',
    components: {
      default: AboutViewMain,
      siderouterview: AboutViewSide,
    },
    beforeEnter(to, from, next) { //Will be called before link is entered
      store.commit('updateMenuOpened', true)
      store.commit('updateCurrentView', 'aboutview')
      /* eslint-disable no-console */
      //console.log('beforeEnter about ; currentRecordType is ' + store.getters.currentRecordType)
      /* eslint-enable no-console */ 
      next()
    },
  },
]

const router = new VueRouter({
  routes,
  store
})

router.beforeEach((to, from, next) => { 

    store.dispatch('getData')
    /* eslint-enable no-console */
    //console.log(store.state.fetchedData)
    //console.log(store.state.fetchedTypefaces)
    //console.log(store.state.fetchedConcepts)
    //console.log(store.state.fetchedResources)
    /* eslint-disable no-console */

    /* eslint-disable no-console */
    //console.log(to.fullPath)
    /* eslint-enable no-console */ 

  //If the link is to /records, see what the currentRecordType is and dynamically re-route
  if((to.fullPath === '/records') || (to.fullPath === '/records/')){
    store.commit('updateMenuOpened', false)
    if(store.getters.currentRecordType == 'typeface'){
      router.push('/records/typeface')
    }
    if(store.getters.currentRecordType == 'concept'){
      router.push('/records/concept')
    }
    if(store.getters.currentRecordType == 'resource'){
      router.push('/records/resource')
    }
  }
  //Get info from link
  /* eslint-disable no-console */
  //console.log('1. Testing before each ; currentRecordType is ' + store.getters.currentRecordType)
  /* eslint-enable no-console */ 
  next()
})

router.afterEach(() => { //beforeEach
  //Get info from link
  /* eslint-disable no-console */
  //console.log('3. Testing after each ; currentRecordType is ' + store.getters.currentRecordType)
//  console.log(router.fullPath)
  /* eslint-enable no-console */ 
})

export default router
